import IPCIDR from "ip-cidr";
import { z } from "zod";
import { BillingDetails, Subscription } from "../billing";
import { DesignSystem } from "../dsm";
import { DbCreateInputOmit, DbUpdateInputOmit, nullishToOptional } from "../helpers";
import { NpmRegistryConfig } from "./npm-registry-settings";
import { SsoProvider } from "./sso-provider";

const isValidCIDR = (value: string) => {
  return IPCIDR.isValidAddress(value);
};

export const WorkspaceIpWhitelistEntry = z.object({
  isEnabled: z.boolean(),
  name: z.string(),
  range: z.string().refine(isValidCIDR, {
    message: "Invalid IP CIDR",
  }),
});

export const WorkspaceIpSettings = z.object({
  isEnabledForCloud: z.boolean(),
  isEnabledForDocs: z.boolean(),
  entries: z.array(WorkspaceIpWhitelistEntry),
});

export const WorkspaceProfile = z.object({
  name: z.string(),
  handle: z.string(),
  color: z.string(),
  avatar: nullishToOptional(z.string()),
  billingDetails: nullishToOptional(BillingDetails),
});

export const WorkspaceProfileUpdate = WorkspaceProfile.omit({
  avatar: true,
});

export type WorkspaceProfileUpdate = z.infer<typeof WorkspaceProfileUpdate>;

export const Workspace = z.object({
  id: z.string(),
  profile: WorkspaceProfile,
  subscription: Subscription,
  ipWhitelist: nullishToOptional(WorkspaceIpSettings),
  sso: nullishToOptional(SsoProvider),
  npmRegistrySettings: nullishToOptional(NpmRegistryConfig),
});

export const WorkspaceWithDesignSystems = z.object({
  workspace: Workspace,
  designSystems: z.array(DesignSystem),
});

export type CreateWorkspaceDbInput = DbCreateInputOmit<Workspace>;
export type UpdateWorkspaceDbInput = DbUpdateInputOmit<Workspace>;

export type WorkspaceIpWhitelistEntry = z.infer<typeof WorkspaceIpWhitelistEntry>;
export type WorkspaceIpSettings = z.infer<typeof WorkspaceIpSettings>;
export type WorkspaceProfile = z.infer<typeof WorkspaceProfile>;
export type Workspace = z.infer<typeof Workspace>;
export type WorkspaceWithDesignSystems = z.infer<typeof WorkspaceWithDesignSystems>;
